import { createContext } from 'react';

const MiuConsumptionContext = createContext();

export default MiuConsumptionContext;